import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 9a5 5 0 1 0 10 0a5 5 0 1 0 -10 0","key":"svg-0"}],["path",{"d":"M12 14l0 7","key":"svg-1"}],["path",{"d":"M9 18l6 0","key":"svg-2"}]]

/**
 * IconVenus
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdmVudXMiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTcgOWE1IDUgMCAxIDAgMTAgMGE1IDUgMCAxIDAgLTEwIDAiIC8+CiAgPHBhdGggZD0iTTEyIDE0bDAgNyIgLz4KICA8cGF0aCBkPSJNOSAxOGw2IDAiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/venus
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconVenus = createReactComponent('outline', 'venus', 'Venus', __iconNode);

export default IconVenus;